/* Chill Out — clickable variant buttons (v3.1.4). Drives the hidden option <select>s that the cart JS (udesly) listens to. */
(function () {
  function init(root) {
    if (root.hasAttribute('data-co-variants-ready')) return;
    root.setAttribute('data-co-variants-ready', '');
    var jsonEl = root.querySelector('[data-co-variant-json]');
    var variants = [];
    try { variants = JSON.parse(jsonEl ? jsonEl.getAttribute('data-co-variant-json') : '[]'); } catch (e) {}
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-co-variants]'));
    if (!groups.length) return;

    function selectFor(group) { return group.closest('fieldset') && group.closest('fieldset').querySelector('select'); }
    function selected() {
      return groups.map(function (g) { var s = selectFor(g); return s ? s.value : null; });
    }
    function refresh() {
      var sel = selected();
      groups.forEach(function (g) {
        var idx = +g.getAttribute('data-option-index');
        var s = selectFor(g);
        g.querySelectorAll('.co-variants__btn').forEach(function (b) {
          var val = b.getAttribute('data-value');
          var on = s && s.value === val;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) { var cur = g.querySelector('[data-co-variant-current]'); if (cur) cur.textContent = b.getAttribute('data-label'); }
          // sold out = no available variant with this value + the other currently chosen options
          var ok = variants.length === 0 || variants.some(function (v) {
            if (!v.a || v.o[idx] !== val) return false;
            for (var i = 0; i < sel.length; i++) { if (i !== idx && sel[i] != null && v.o[i] !== sel[i]) return false; }
            return true;
          });
          b.classList.toggle('is-soldout', !ok);
        });
      });
    }
    groups.forEach(function (g) {
      var s = selectFor(g);
      if (!s) return;
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.co-variants__btn');
        if (!b) return;
        s.value = b.getAttribute('data-value');
        s.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
      });
      g.addEventListener('keydown', function (e) {
        if (['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].indexOf(e.key) < 0) return;
        var btns = Array.prototype.slice.call(g.querySelectorAll('.co-variants__btn'));
        var i = btns.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault();
        var n = btns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : btns.length - 1)) % btns.length];
        n.focus(); n.click();
      });
      s.addEventListener('change', refresh);
    });
    refresh();
    // the cart script sets the starting variant (incl. ?variant= links) after load — re-sync
    setTimeout(refresh, 300); setTimeout(refresh, 1200);
  }
  function boot() {
    document.querySelectorAll('form').forEach(function (f) { if (f.querySelector('[data-co-variants]')) init(f); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
